import { Expose, Transform, TransformFnParams } from "@nts/std/serialization";
import { DateTime } from "@nts/std/types";

export class GetExchangeRateRequestDto {

  @Expose()
  public isoCode: string;

  @Expose()
  @Transform(DateTime.transform)
  public referenceDate: DateTime;
}
